import { PROFILE_TYPES } from '@/utils/enums';
import Dashboard from '@/layouts/Dashboard';
import affiliateRoutes from './affiliate';
import specialistRoutes from './specialist';
import developerRoutes from './developer';

const router = [
    {
        path: '/',
        component: Dashboard,
        meta: { auth: true },
        children: [
            {
                path: '',
                component: () => import('@/views/home'),
                name: 'home',
                meta: { auth: true, title: 'Início' },
            },
            {
                path: '/bank-account',
                name: 'bank-account',
                component: () => import('@/views/bank'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.AFFILIATE, PROFILE_TYPES.SPECIALIST], title: 'Conta bancária' },
            },
            {
                path: '/commission',
                name: 'commission',
                component: () => import('@/views/commission'),
                meta: { auth: true, allowRoles: [PROFILE_TYPES.AFFILIATE, PROFILE_TYPES.SPECIALIST], title: 'Comissão' },
            },
            {
                path: '/dashboard',
                name: 'dash',
                component: () => import('@/views/dash'),
                meta: {
                    auth: true,
                    hasQueryParamPage: true,
                    title: 'Visão Geral',
                },
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('@/views/profile'),
                meta: { auth: true, title: 'Editar perfil' },
            },
            ...affiliateRoutes,
            ...specialistRoutes,
            ...developerRoutes,
        ],
    },
];

export default router;
